import { render, staticRenderFns } from "./lazyLoading.vue?vue&type=template&id=184eff33&scoped=true"
import script from "./lazyLoading.vue?vue&type=script&lang=js"
export * from "./lazyLoading.vue?vue&type=script&lang=js"
import style0 from "./lazyLoading.vue?vue&type=style&index=0&id=184eff33&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184eff33",
  null
  
)

export default component.exports